




// instagram script 
// for more info: https://github.com/stevenschobert/instafeed.js
if ($('#instafeed').length >= 1) {
  $(document).ready(function () {
    var userFeed = new Instafeed({
      get: 'user',
      userId: '227069917',
      limit: 4,
      resolution: "standard_resolution",
      accessToken: '227069917.3c4e68d.48562f9b2b57417fbf53b24a03b35b21',
      sortBy: "most-recent",
      template: '<div class="gallery"><a href="{{link}}" title={{caption}} target="_blank"><img src="{{image}}" alt="{{caption}}" class="img-fluid"/></a></div>',
    });
    userFeed.run();
  });
}


//console.log(line_item);


/* 
MEGA MENU 
//
https://www.jqueryscript.net/menu/sticky-responsive-mega-menu.html 
//
*/

/* Initialize the mega menu with default settings. */
$(".mega-menu").megaMenu({
  /*  Make the mega menu sticky when scrolling down the page. Default: true */
  stickyHeader: true,
  /* Customize the trigger event to toggle the submenu. Default: 'click'. */
  //menuBehaviour: "mouseover",
  /* Customize the caret */
  caret: "",
  caretArrows: [{
    up:"fa fa-angle-up",
    down:"fa fa-angle-down",
    upUrl: "",
    downUrl: "",
  }],
  /* Customize the open/ close animations */
  animation: true,
  animationClass: "animated fadeIn",
  /* Highlight the activate menu items */
  highlighter: true,
  followingHighlighter: false,
  highlightColor: "#D4AF37",
  textHighlighterColor: ""

});

/* if($('.main-links').hasClass('active')){
  $('.mobile-toggler').removeClass('fa-bars').addClass('fa-times');
} */


// Get a NodeList of all .num-dol elements from the tags and format them to money 
const moneyAmount = document.querySelectorAll('.num-dol');
//console.log(moneyAmount);

for (i = 0; i < moneyAmount.length; ++i) {
  console.log(moneyAmount[i].value);
  /* divs[i].style.color = "green"; */
  if (moneyAmount[i].value == "pri-under-10") {
    moneyAmount[i].textContent = "under $10,000";
    //console.log(this.textContent);
  }
  if (moneyAmount[i].value == "pri-10-15"){
    moneyAmount[i].textContent = "$10,000 - $15,000";
    //console.log(this.textContent);
  }
  if (moneyAmount[i].value == "pri-15-25") {
    moneyAmount[i].textContent = "$15,000 - $25,000";
    //console.log(this.textContent);
  }
  if (moneyAmount[i].value == "pri-over-25") {
    moneyAmount[i].textContent = "Over $25,000";
    //console.log(this.textContent);
  }
}

/* Toggle contact for product pages */
$(document).ready(function(){
  $(".call-watch").click(function () {
    $(".add-bottom").addClass("btm-margin");
    $(".toggle-phone").toggle();
  });
});


/* if ($(".shopify-payment-button__more-options").hasClass('.shopify-payment-button__button--hidden')) { 
  $('.product-single__add-to-cart--full-width').css("height","auto");
} else{
  $('.product-single__add-to-cart--full-width').css("height", "109px");
} */

/* if ($('.shopify-payment-button__button--hidden').length()) {
  $('.product-single__add-to-cart--full-width').css("height", "109px");
} else {
  $('.product-single__add-to-cart--full-width').css("height", "auto");
} */


/* if (template === 'product') {
  var productData = ('{{ product | json}}');
  console.log('{{ product | json }}');
} */

/* console.log({{ product | json }});

var productData = {{product | json }};

var theId = JSON.parse(productData[0]);

console.log(obj.theId);

var storedTitle = localStorage.getItem("title");
console.log("stored title is: " + storedTitle); */

/* window.addEventListener('load', function () {
  var inputBox = document.getElementById("input_7").innerHTML.value = "'" + storedTitle + "'";;
  inputBox.value = "storedTitle";
  document.getElementById("input_7").value = 'storedValue';
}) */

// Get a reference to the DOM element.
// Make sure this is done AFTER the DOM has finished loading:
//var formBox = document.getElementById("200355910368049");

// Register a function to the image's load event handlers:
//formBox.addEventListener("load", doLoad);

// Declare the callback function:
//function doLoad() {
  //var inputBox = document.getElementById("input_7").innerHTML.value = "'" + storedTitle + "'";;
  //inputBox.value = "storedTitle";
  //document.getElementById("input_11").value = storedValue;

  //document.getElementById("input_11").setRangeText(storedValue);
  //document.getElementById("inputTitle").value = storedTitle;
  //$('#inputTitle').val(storedTitle);

//}

/* var text = document.getElementById('text');
text.value += ' after clicking'; */

/* Smithtown click to contact 
$("#clickSmithtown").click(function () {
  $('html,body').animate({
    scrollTop: $(".jotform-form").offset().top
  },
    'slow');
});*/

/* $("#clickSmithtown").click(function () {
  $('html, body').animate({
    scrollTop: $("jotform-form").offset().top
  }, 2000);
}); */

/* $("#clickSmithtown").click(function () {
  $([document.documentElement, document.body]).animate({
    scrollTop: $("#200407229491148").offset().top
  }, 'slow');
});

$("#clickSmithtown").click(function () {
  $('html,body').animate({
    scrollTop: $("#200407229491148").offset().top
  });
}); */

$("#clickSmithtown").click(function () {
  $('html, body').animate({
    scrollTop: $("#JotFormIFrame-200407229491148").offset().top}, 2000);
});

$("#clickSmithtownAdd").click(function () {
  $('html, body').animate({
    scrollTop: $("#200407229491148").offset().top
  }, 2000);
});

$("#clickSmithtown-questions").click(function () {
  $([document.documentElement, document.body]).animate({
    scrollTop: $("#sell-gold-smithtown").offset().top
  }, 'slow');
});

$("#testimonials-scroll").click(function () {
  $([document.documentElement, document.body]).animate({
    scrollTop: $("#testimonials-smithtown").offset().top
  }, 'slow');
});

$("#testimonials-scroll-mobile").click(function () {
  $([document.documentElement, document.body]).animate({
    scrollTop: $("#testimonials-smithtown").offset().top
  }, 'slow');
});

$("#click-trade-contact").click(function () {
  $([document.documentElement, document.body]).animate({
    scrollTop: $("#trade-form-dynamic").offset().top
  }, 'slow');
});

$("#clickSmithtown-trade").click(function () {
  $([document.documentElement, document.body]).animate({
    scrollTop: $("#trade-form-dynamic").offset().top
  }, 'slow');
});


$(".clearSku").click(function () {
  localStorage.removeItem("sku");
});

/* Massapequa contact / trade  Functions */
$(".smithtownEmailTrade").click(function () {
  localStorage.setItem("title", theTitle);
  var storedTitle = localStorage.getItem("title");
  console.log("stored title is: " + storedTitle);

  localStorage.setItem("sku", theSku);
  var storedSku = localStorage.getItem("sku");
  console.log("stored sku is: " + storedSku);
  var url = "https://www.collectors1946.com/pages/trade-in-my-watch-smithtown/#JotFormIFrame-202957957763069";
  window.open(url);
});

$(".smithtownEmail").click(function () {
  localStorage.setItem("title", theTitle);
  var storedTitle = localStorage.getItem("title");
  console.log("stored title is: " + storedTitle);

  localStorage.setItem("sku", theSku);
  var storedSku = localStorage.getItem("sku");
  console.log("stored sku is: " + storedSku);
  var url = "https://www.collectors1946.com/pages/smithtown/#JotFormIFrame-200407229491148";
  window.open(url);
});

/* Massapequa contact / trade  Functions */
$(".massEmailTrade").click(function () {
  localStorage.setItem("title", theTitle);
  var storedTitle = localStorage.getItem("title");
  console.log("stored title is: " + storedTitle);

  localStorage.setItem("sku", theSku);
  var storedSku = localStorage.getItem("sku");
  console.log("stored sku is: " + storedSku);
  var url = "https://www.collectors1946.com/pages/trade-in-or-sell-your-items-massapequa-park/#JotFormIFrame-203027981060146";
  window.open(url);
});

$(".massEmail").click(function () {
  localStorage.setItem("title", theTitle);
  var storedTitle = localStorage.getItem("title");
  console.log("stored title is: " + storedTitle);

  localStorage.setItem("sku", theSku);
  var storedSku = localStorage.getItem("sku");
  console.log("stored sku is: " + storedSku);
  var url = "https://www.collectors1946.com/pages/massapequa-park2/#JotFormIFrame-200407023791143";
  window.open(url);
});

/* Huntington click functions huntEmailTrade */
$(".huntEmailTrade").click(function () {
  localStorage.setItem("title", theTitle);
  var storedTitle = localStorage.getItem("title");
  console.log("stored title is: " + storedTitle);

  localStorage.setItem("sku", theSku);
  var storedSku = localStorage.getItem("sku");
  console.log("stored sku is: " + storedSku);
  var url = "https://www.collectors1946.com/pages/trade-in-or-sell-your-watch-to-our-huntington-location/#JotFormIFrame-203065681938159";
  window.open(url);
});

$(".huntEmail").click(function () {
  localStorage.setItem("title", theTitle);
  var storedTitle = localStorage.getItem("title");
  console.log("stored title is: " + storedTitle);

  localStorage.setItem("sku", theSku);
  var storedSku = localStorage.getItem("sku");
  console.log("stored sku is: " + storedSku);
  var url = "https://www.collectors1946.com/pages/huntington/#JotFormIFrame-200355910368049";
  window.open(url);
});



$("#productEmailLynbrook").click(function () {
  localStorage.setItem("title", theTitle);
  var storedTitle = localStorage.getItem("title");
  console.log("stored title is: " + storedTitle);

  localStorage.setItem("sku", theSku);
  var storedSku = localStorage.getItem("sku");
  console.log("stored sku is: " + storedSku);
  var url = "https://www.collectors1946.com/pages/lynbrook/#JotFormIFrame-200407977903156";
  window.open(url);
});

$("#productEmailBaldwin").click(function () {
  localStorage.setItem("title", theTitle);
  var storedTitle = localStorage.getItem("title");
  console.log("stored title is: " + storedTitle);

  localStorage.setItem("sku", theSku);
  var storedSku = localStorage.getItem("sku");
  console.log("stored sku is: " + storedSku);
  var url = "https://www.collectors1946.com/pages/baldwin/#JotFormIFrame-200407262803142";
  window.open(url);
});

$("#productEmailMass").click(function () {
  localStorage.setItem("title", theTitle);
  var storedTitle = localStorage.getItem("title");
  console.log("stored title is: " + storedTitle);

  localStorage.setItem("sku", theSku);
  var storedSku = localStorage.getItem("sku");
  console.log("stored sku is: " + storedSku);
  var url = "https://www.collectors1946.com/pages/massapequa-park2/#JotFormIFrame-200407023791143";
  window.open(url);
});



$("#clickMass").click(function () {
  $([document.documentElement, document.body]).animate({
    scrollTop: $("#JotFormIFrame-200407023791143").offset().top
  }, 'slow');
});

/* click to contact for items over 30k */
$("#contactOver30k").click(function () {
  localStorage.setItem("title", theTitle);
  localStorage.setItem("vendor", theVendor);
  var storedVendor = localStorage.getItem("vendor");
  var storedTitle = localStorage.getItem("title");
  //console.log("stored title is: " + storedTitle);
  //console.log("stored Vendor is: " + storedVendor);
  localStorage.setItem("sku", theSku);
  var storedSku = localStorage.getItem("sku");
  console.log("stored sku is: " + storedSku);
  if (storedVendor == "Massapequa Park"){
    var url = "https://www.collectors1946.com/pages/massapequa-park2/#JotFormIFrame-200407023791143";
  }
  else if (storedVendor == "Huntington"){
    var url = "https://www.collectors1946.com/pages/huntington/#JotFormIFrame-200355910368049";
  }
  else if (storedVendor == "Smithtown"){
    var url = "https://www.collectors1946.com/pages/smithtown/#JotFormIFrame-200407229491148";
  }
  else if (storedVendor == "Baldwin"){
    var url = "https://www.collectors1946.com/pages/baldwin/#JotFormIFrame-200407262803142";
  }
  else if (storedVendor == "Lynbrook") {
    var url = "https://www.collectors1946.com/pages/lynbrook/#JotFormIFrame-200407977903156";
  }
  else {
    var url = "https://www.collectors1946.com/pages/contact-us"
  }

  
  window.open(url);
});

/* Footer remove Loc */
/* var theMainLocH = document.getElementsByClassName("h-loc");
if (theMainLocH.length > 1){
  var theRemoveLocH = document.getElementsByClassName("h-loc-delete");
  theRemoveLocH.classList.add("deleteLoc");
}
 */
if ($(".h-loc").length > 0) {
  $(".h-loc-delete").addClass("deleteloc");
}

if ($(".m-loc").length > 0) {
  $(".m-loc-delete").addClass("deleteloc");
}

if ($(".s-loc").length > 0) {
  $(".s-loc-delete").addClass("deleteloc");
}

if ($(".l-loc").length > 0) {
  $(".l-loc-delete").addClass("deleteloc");
}

if ($(".b-loc").length > 0) {
  $(".b-loc-delete").addClass("deleteloc");
}

if ($(".o-loc").length > 0) {
  $(".o-loc-delete").addClass("deleteloc");
}

/* 
productEmailBaldwin
clickMass
mass
JotFormIFrame-200407023791143
productEmailMass
https://www.collectors1946.com/pages/trade-in-my-watch-smithtown/#JotFormIFrame-202957957763069 */




/* https://www.collectors1946.com/pages/trade-in-my-watch-smithtown#trade-form-dynamic */

/* $("#tradeLinkClick").click(function () {
  const skuNum = localStorage.getItem('sku');
  console.log("stored sku is: " + skuNum);
  var url = "https://www.collectors1946.com/pages/trade-in-my-watch-smithtown"
  window.open(url)
  (document.getElementById("click-trade-contact"), 'click');
});
document.getElementById("click-trade-contact"), 'click'; */
/* $("#202957957763069").load(function () {
  $([document.documentElement, document.body]).animate({
    scrollTop: $("#trade-form-dynamic").offset().top
  }, 'slow');
}); */



/* $(".clickFormTrade").click(function () {
  const skuNum = localStorage.getItem('sku');
  console.log("stored sku is: " + skuNum);
  if (typeof skuNum !== "undefined") {
    var url = ("https://form.jotform.com/202957957763069" + "?whichWatches="+ skuNum);
  }
  else{
    var url = ("https://form.jotform.com/202957957763069");
  }
  window.open(url, "_blank");
});
 */
/* var elem = document.getElementById("trade-form-dynamic");
var newScript = document.createElement("script");
newScript.type = "text/javascript";
newScript.src = "https://form.jotform.com/jsform/202957957763069";
elem.appendChild(newScript);
newScript.reload(); */

/* function load_js() {
  var newScript = document.getElementsById('trade-form-dynamic')[0];
  var script = document.createElement('script');
  script.type = "text/javascript";
  script.src = 'https://form.jotform.com/jsform/202957957763069';
  newScript.appendChild(script);
}
load_js(); */

/* $(window).load(function () {
  var urlForm = document.getElementById('theTradeFormLink');
  urlForm.removeAttribute("src");
  console.log(urlForm);

});
 */


/* var elem = document.getElementById("trade-form-dynamic");
var newScript = document.createElement("script");
newScript.type = "text/javascript";
newScript.src = "https://form.jotform.com/jsform/202957957763069";
elem.appendChild(newScript); */

/* var theScript = document.getElementById("tradeContactScript");
console.log(theScript);
theScript.removeAttribute('src');
console.log(theScript); */

/* var createScript = document.createElement('script');
createScript.type = "text/javascript";
createScript.src = "https://form.jotform.com/jsform/202957957763069";
var theFormDiv = document.getElementById("trade-form-dynamic");
theFormDiv.innerHTML(createScript);
 */

/* const skuNum = localStorage.getItem('sku');
console.log("stored sku is: " + skuNum);
var urlForm = document.getElementById('theTradeFormLink');
console.log(urlForm);
urlForm.setAttribute("src", "https://form.jotform.com/202957957763069"); */
/* if (typeof skuNum !== "undefined") {
  console.log("Hi. Variable is defined.");
  urlForm.setAttribute("src", '"https://form.jotform.com/202957957763069"+"?whichWatch"+skuNum;');
  console.log(urlForm.src);
  var url = ""
} 
else {
  urlForm.src = "https://form.jotform.com/202957957763069"
} */

/* var script = document.getElementById('theTradeFormLink');
script.onload = function () {
  var theSku = localStorage.getItem('sku');
  if (theSku !== "undefined") {
    script.setAttribute('src', ("https://form.jotform.com/202957957763069" + "?whichWatch" + theSku));
  }
  else {
    script.setAttribute('src', 'https://form.jotform.com/202957957763069');
  }
};
document.head.appendChild(script); */

/* function getSrc(){
  var theSku = localStorage.getItem('sku');
  if (theSku !== "undefined") {
    script.setAttribute('src', ("https://form.jotform.com/202957957763069" + "?whichWatch" + theSku));
  }
  else {
    script.setAttribute('src', 'https://form.jotform.com/202957957763069');
  }
} */

/* var ref = document.getElementById('dynamic-contact-trades'),
script = document.createElement('script');
script.setAttribute('type', 'text/javascript');
script.setAttribute('src', 'https://form.jotform.com/202957957763069');
script.setAttribute('id', 'newTransition');
ref.parentNode.insertBefore(script, ref); */

/* var theIfSrc = document.getElementById("JotFormIFrame-202957957763069").src;
var theIf = document.getElementById("JotFormIFrame-202957957763069");
console.log(theIfSrc);
var theSku = localStorage.getItem('sku');
if (theSku !== "undefined") {
  theIf.setAttribute('src', ("https://form.jotform.com/202957957763069" + "?whichWatch" + theSku));
}
else {
  theIf.setAttribute('src', 'https://form.jotform.com/202957957763069');
} */

/* const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = "";
  script.async = true;
  script.dataset.cfasync = false;
  document.body.appendChild(script);
  script.addEventListener("load", () => {
  console.log("Script added successfully");
  resolve();
}); */